"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _attributeOption = _interopRequireDefault(require("../attributeOption"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AttributeOptions = function AttributeOptions(_ref) {
  var attributeId = _ref.attributeId,
      parentId = _ref.parentId,
      parent = _ref.parent,
      attributeName = _ref.attributeName,
      type = _ref.type,
      options = _ref.options,
      sortOptions = _ref.sortOptions,
      onChange = _ref.onChange,
      value = _ref.value,
      setFieldValue = _ref.setFieldValue;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-wrap"
  }, Object.keys(options).map(function (optionId) {
    return _objectSpread({
      key: optionId
    }, options[optionId]);
  }).sort(function (option1, option2) {
    return sortOptions ? option1.name.localeCompare(option2.name) : -1;
  }).map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_attributeOption.default, {
      key: "attribute-option-".concat(option.key),
      type: type,
      attributeId: attributeId,
      parentId: parentId,
      parent: parent,
      attributeName: attributeName,
      optionId: option.key,
      value: value,
      onChange: onChange,
      setFieldValue: setFieldValue,
      option: option
    });
  }));
};

var _default = AttributeOptions;
exports.default = _default;